var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Page',{attrs:{"actionBarHidden":"true"}},[_c('StackLayout',{staticClass:"spinner",attrs:{"height":"100%","isPassThroughParentEnabled":"false"},on:{"tap":function () {}}},[_c('Spinner',{attrs:{"height":"100%"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }